import { useEffect, useState } from "react";
import { Info, X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface FirstVisitHintProps {
  token: string;
}

function key(token: string) {
  return `city_review_hint_dismissed_${token}`;
}

export function FirstVisitHint({ token }: FirstVisitHintProps) {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    try {
      setDismissed(localStorage.getItem(key(token)) === "1");
    } catch {
      setDismissed(false);
    }
  }, [token]);

  if (dismissed) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(key(token), "1");
    } catch {
      /* noop */
    }
    setDismissed(true);
  };

  return (
    <div className="flex items-center gap-3 rounded-lg border border-primary/30 bg-primary/5 px-4 py-3 text-sm">
      <Info className="size-4 shrink-0 text-primary" />
      <div className="flex-1">
        <strong className="font-medium">Tip:</strong>{" "}
        Click a station pin or table row to review photos and leave feedback.
      </div>
      <Button
        variant="ghost"
        size="icon-sm"
        onClick={dismiss}
        aria-label="Dismiss hint"
      >
        <X className="size-4" />
      </Button>
    </div>
  );
}
